import React from 'react';
import { Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

const GreyBox = () => {
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).Common.greyBox;
  return (
    <Stack
      flexDirection={'row'}
      alignItems={'flex-start'}
      gap={'15px'}
      padding={'25px 15px'}
      width={'100%'}
      sx={{ border: '1px solid #777777', backgroundColor: '#EEEEEE' }}
    >
      <InfoOutlinedIcon sx={{ color: '#333333' }} />
      <Stack gap={'5px'}>
        <Typography variant="body1-bold">{i18n.title}</Typography>
        <Typography variant="body2">{i18n.subtitle}</Typography>
      </Stack>
    </Stack>
  );
};
export default GreyBox;
